import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import BusinessService from "./Businesses.service.js";
import AuthService from "../Authentication/auth.service.js";
import Alerts from "../../components/Alerts/alerts.js";
import { getFileUrl } from "../../utils/fileUtils";
import { SensitiveImage, SensitiveText } from "../../context/SensitiveInfoContext";
import ImagePreviewModal from "../../components/Modals/ImagePreviewModal";

const TabGenralDoctor = ({ business_id }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState("");

  const [data, setData] = useState({
    full_name: '',
    gender: '',
    biography: '',
    dob: '',
    specialization: '',
    rate: '',
    phone: '',
    selected_off_days: [],
    selected_weekday_times: [],
    selected_weekend_times: [],
    image: '',
    email: '',
    type: '',
    password: '',
    status: '',
    document_action: '',
    document_msg: '',
    experience: '',
    medical_license_no: '',
    clinic_name: '',
    mmc_expiry_datetime: '',
    ic_no: '',
    ic_ocr_number: '',
    ic_image: '',
    IC_Verification: '',
    ic_verification_reason: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      BusinessService.GetSingleDoctor(business_id).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else if (response.data.status === true) {
          const doctor = response.data.data.data;
          setData({
            full_name: doctor.full_name,
            gender: doctor.gender,
            biography: doctor.biography,
            dob: doctor.dob,
            specialization: doctor.specialization,
            rate: doctor.rate,
            phone: doctor.phone,
            selected_off_days: doctor.selected_off_days || [],
            selected_weekday_times: doctor.selected_weekday_times || [],
            selected_weekend_times: doctor.selected_weekend_times || [],
            image: doctor.image,
            email: doctor.email,
            type: doctor.type,
            password: doctor.password,
            document_action: doctor.document_action,
            document_msg: doctor.document_msg,
            status: doctor.status,
            experience: doctor.experience,
            medical_license_no: doctor.medical_license_no,
            clinic_name: doctor.clinic_name,
            mmc_expiry_datetime: doctor.mmc_expiry_datetime,
            ic_no: doctor.ic_no || '',
            ic_ocr_number: doctor.ic_ocr_number || '',
            ic_image: doctor.ic_image || '',
            IC_Verification: doctor.IC_Verification || 'pending',
            ic_verification_reason: doctor.ic_verification_reason || '',
          });
        } else {
          Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      });
    };
    fetchData();
  }, [business_id]);

  return (
    <Fragment>
      <Row>
        <Col md="12">
          <Card className="main-card">
            <LoadingOverlay tag="div" active={loading} spinner={<DNALoader />}>
              <CardBody>
                <table className="table table-striped table-bordered nowrap">
                  <tbody>
                    <tr style={{ width: '100%' }}>
                      <th style={{ width: '50%' }}>{t('Full Name')}</th>
                      <td style={{ width: '50%' }}>{data.full_name}</td>
                    </tr>
                    <tr>
                      <th>{t('Email')}</th>
                      <td>{data.email}</td>
                    </tr>
                    <tr>
                      <th>{t('Type')}</th>
                      <td>{data.type}</td>
                    </tr>
                    <tr>
                      <th>{t('Gender')}</th>
                      <td>{data.gender}</td>
                    </tr>
                    <tr>
                      <th>{t('Date of birth')}</th>
                      <td>{data.dob}</td>
                    </tr>
                    <tr>
                      <th>{t('Consultancy Charges')}</th>
                      <td>RM {data.rate}</td>
                    </tr>
                    <tr>
                      <th>{t('Phone')}</th>
                      <td>{data.phone}</td>
                    </tr>
                    <tr>
                      <th>{t('NRIC')}</th>
                      <td><SensitiveText value={data.ic_no} /></td>
                    </tr>
                    <tr>
                      <th>{t('OCR Extracted NRIC')}</th>
                      <td><SensitiveText value={data.ic_ocr_number} /></td>
                    </tr>
                    <tr>
                      <th>{t('IC Verification')}</th>
                      <td>{data.IC_Verification || "pending"}</td>
                    </tr>
                    {data.ic_verification_reason ? (
                      <tr>
                        <th>{t('IC Verification Reason')}</th>
                        <td>{data.ic_verification_reason}</td>
                      </tr>
                    ) : null}
                    <tr>
                      <th>{t('IC Image')}</th>
                      <td>
                        {data.ic_image ? (
                          <SensitiveImage
                            src={getFileUrl(data.ic_image)}
                            alt="IC"
                            style={{ width: "80px", height: "50px", objectFit: "cover", borderRadius: "6px", cursor: "pointer" }}
                            onClick={() => {
                              setPreviewImage(getFileUrl(data.ic_image));
                              setPreviewTitle(t("IC Image"));
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Biography')}</th>
                      <td>{data.biography}</td>
                    </tr>
                    <tr>
                      <th>{t('Specialization')}</th>
                      <td>{data.specialization}</td>
                    </tr>
                    <tr>
                      <th>{t('Yeas of Experience')}</th>
                      <td>{data.experience}</td>
                    </tr>
                    <tr>
                      <th>{t('Mdeical License No')}</th>
                      <td><SensitiveText value={data.medical_license_no} /></td>
                    </tr>
                    <tr>
                      <th>{t('Clinic Name')}</th>
                      <td>{data.clinic_name}</td>
                    </tr>
                    <tr>
                      <th>{t('Profile Image')}</th>
                      <td>
                        {data.image && data.image !== 'test' ? (
                          <SensitiveImage
                            src={getFileUrl(data.image)}
                            alt={data.full_name}
                            style={{ width: "50px", height: "50px", borderRadius: "100%", cursor: "pointer" }}
                            onClick={() => {
                              setPreviewImage(getFileUrl(data.image));
                              setPreviewTitle(t("Profile Image"));
                            }}
                          />
                        ) : (
                          <span>{t('No Image')}</span>
                        )}
                      </td>
                    </tr>

                    {data.mmc_expiry_datetime && (
                      <tr>
                        <th>{t('MMC Registration Certificate Expiry')}</th>
                        <td>
                          {(() => {
                            const dateObj = new Date(data.mmc_expiry_datetime);
                            const day = dateObj.getDate();
                            const month = dateObj.toLocaleString('default', { month: 'long' });
                            const year = dateObj.getFullYear();
                            const time = dateObj.toLocaleTimeString();
                            return `${day} ${month} ${year},  ${time}`;
                          })()}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <th>{t('Selected Off Days')} (Current Year)</th>
                      <td>
                        {data.selected_off_days.length > 0
                          ? data.selected_off_days.join(', ')
                          : t('No off days available.')}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Weekday Availability')}</th>
                      <td>
                        {data.selected_weekday_times.length > 0
                          ? data.selected_weekday_times.join(', ')
                          : t('No weekday times available.')}
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Weekend Availability')}</th>
                      <td>
                        {data.selected_weekend_times.length > 0
                          ? data.selected_weekend_times.join(', ')
                          : t('No weekend times available.')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CardBody>
            </LoadingOverlay>
          </Card>
        </Col>
      </Row>

      <ImagePreviewModal
        show={!!previewImage}
        onClose={() => {
          setPreviewImage(null);
          setPreviewTitle("");
        }}
        src={previewImage}
        title={previewTitle}
      />
    </Fragment>
  );
};

export default TabGenralDoctor;
